var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrazilNuts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#FEE0B4;}\n\t.st2{fill:#EE744B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.58,66.69c-1.02-0.54-2.12-0.91-3.25-1.1c7.71,9.77,10.04,31.3-4.2,58.52 c-10.09,19.28-26.48,27.55-38.66,26.05c0.77,0.63,1.63,1.22,2.62,1.73c11.86,6.21,32.53-0.97,44.36-23.57 C162.14,96.39,155.59,72.46,144.58,66.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.13,124.11c14.24-27.22,11.91-48.75,4.2-58.52c-5.75-0.99-12.64,2.59-18.07,12.97 c-6.5,12.43-19.21,36.72-26.46,50.57c-3.94,7.52-4.4,16.01,1.67,21.02C110.65,151.66,127.04,143.39,137.13,124.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.33,65.59c-5.75-0.99-12.64,2.59-18.07,12.97c-0.08,0.15-0.16,0.3-0.24,0.46 c3.05-1.26,6.81-6.25,8.07-6.49c1.6-0.3-0.41,5.6,2.54,8.22c2.95,2.62,8.97,0.74,9.82,1.18c0.85,0.44,0.62,5,2.46,5.61 c0.59,0.19,1.09,0.27,1.56,0.36C147.62,78.09,145.13,70.41,141.33,65.59z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M150.71,90.05c1.15,1.45,3.15,4.84,4.61,7.39c1.54-15.91-3.68-27.05-10.74-30.74 c-1.02-0.54-2.12-0.91-3.25-1.1c3.8,4.82,6.3,12.5,6.14,22.31C148.48,88.09,149.38,88.37,150.71,90.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M132.02,136.77c-2.13-0.75,5.46-9.74,6.11-14.43c0.01-0.09,0.02-0.18,0.03-0.27 c-0.34,0.68-0.68,1.36-1.04,2.04c-8.25,15.77-20.72,24.18-31.65,25.89c-0.67,1-1.29,2.06-1.79,2.98 c9.03,3.01,21.72-0.51,32.15-11.24C135.47,139.36,133.35,137.23,132.02,136.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.13,124.11c0.36-0.68,0.7-1.36,1.04-2.04c0.37-4.1-5.85,3.81-8.3,7.82c-2.5,4.09-6.36,4.59-9.34,4.11 c-2.99-0.48-4.62,3.34-5,5.42c-0.37,2.09-4.2,5.96-7,7.37c-1.01,0.51-2.09,1.79-3.05,3.22 C116.41,148.28,128.88,139.87,137.13,124.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M102.4,118.42c0.52,0.34,1.19,0.46,2.02-0.05c2.21-1.36,2.92-3.87,4.43-5.6c1.51-1.73,5.13,0.53,7.17-4.52 c2.04-5.05,0.83-7.81-0.67-8.43c-0.57-0.23-1.55-0.73-2.56-1.26C109.33,105.18,105.68,112.15,102.4,118.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.38,61c-1.13,0.24-2.21,0.65-3.21,1.22c12.17,2.61,27.69,17.71,34.08,47.76 c4.52,21.29-2.83,38.11-13.17,44.71c1,0,2.04-0.11,3.12-0.34c13.1-2.78,24.44-21.49,19.14-46.44 C105.85,72.68,85.55,58.42,73.38,61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.26,109.98c-6.39-30.05-21.91-45.15-34.08-47.76c-5.06,2.9-8.09,10.06-5.65,21.52 c2.92,13.72,8.62,40.54,11.86,55.82c1.77,8.3,6.82,15.14,14.69,15.13C101.43,148.09,108.78,131.27,104.26,109.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.18,62.22c-5.06,2.9-8.09,10.06-5.65,21.52c0.04,0.17,0.07,0.34,0.11,0.51c1.55-2.91,1.26-9.16,2.08-10.15 c1.04-1.25,3.25,4.57,7.19,4.71c3.94,0.14,7.38-5.15,8.31-5.35c0.94-0.2,3.67,3.46,5.47,2.75c0.57-0.23,1.01-0.49,1.43-0.72 C83,67.84,76.18,63.51,70.18,62.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M93,75.09c1.81,0.38,5.52,1.72,8.26,2.75C92.3,64.6,81.17,59.35,73.38,61c-1.13,0.24-2.21,0.65-3.21,1.22 c6,1.29,12.82,5.61,18.95,13.27C90.04,75,90.91,74.64,93,75.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M108.4,122.99c-2.12,0.78-2.01-10.98-4.5-15.02c-0.05-0.08-0.1-0.15-0.15-0.22c0.17,0.74,0.34,1.48,0.5,2.24 c3.7,17.41-0.54,31.83-7.87,40.13c0.12,1.19,0.32,2.41,0.53,3.44c8.88-3.44,16.41-14.24,17.6-29.16 C112.71,122.79,109.71,122.5,108.4,122.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M104.26,109.98c-0.16-0.76-0.33-1.5-0.5-2.24c-2.33-3.39-2.08,6.66-1.41,11.31c0.68,4.74-1.97,7.59-4.58,9.12 c-2.61,1.53-1.43,5.52-0.39,7.36c1.04,1.84,0.57,7.27-0.69,10.14c-0.45,1.04-0.47,2.71-0.3,4.42 C103.71,141.82,107.96,127.39,104.26,109.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.88,127.74c0.62-0.06,1.21-0.4,1.52-1.33c0.84-2.46-0.21-4.84-0.16-7.14c0.06-2.29,4.29-2.87,2.64-8.06 c-1.65-5.19-4.34-6.55-5.9-6.07c-0.59,0.18-1.66,0.42-2.78,0.66C70.77,113.13,72.41,120.82,73.88,127.74z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilNuts);
export default __webpack_public_path__ + "static/media/Brazil_nuts.5188e4bbfd942c7e8576778e1851e92d.svg";
export { ForwardRef as ReactComponent };